/**
 * Formats reading time with proper internationalization
 * @param minutes - Number of minutes
 * @param translator - The translation function from svelte-i18n
 * @returns Formatted reading time string
 */
export function formatReadingTime(minutes: number, translator: any): string {
  return translator('common.readingTime', { values: { minutes } });
}

/**
 * Calculates reading time based on word count
 * @param wordCount - Number of words in the text
 * @param wordsPerMinute - Reading speed (default: 200 words per minute)
 * @returns Number of minutes to read
 */
export function calculateReadingTime(wordCount: number, wordsPerMinute: number = 200): number {
  return Math.ceil(wordCount / wordsPerMinute);
}

/**
 * Gets formatted reading time from word count
 * @param wordCount - Number of words in the text
 * @returns Formatted reading time string
 */
export function getReadingTime(wordCount: number): string {
  const minutes = calculateReadingTime(wordCount);
  return formatReadingTime(minutes);
}